import { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

export interface DetailsTableWrapperProps {
  children: ReactNode
  className?: string
}

export function DetailsTableWrapper({ children, className }: DetailsTableWrapperProps) {
  return (
    <div
      className={twMerge('border-shades-200 text-shades-600 overflow-hidden rounded border-y md:border-x', className)}
    >
      {children}
    </div>
  )
}

export default DetailsTableWrapper
